module.exports = __webpack_public_path__ + "static/media/results-image3.b9c7eb93.png";